import * as BABYLON from 'babylonjs';
import * as Material from 'babylonjs-materials';
export class Geomodeln{
    constructor(game,url,modelname,id){
        this.scene=game.scene;
        this.engine = game.engine;
        this.xray=false;
        this.normalDisplayMaterials = [];
        this.model = null;
        this.size = null;
        this.id = id;
        this.grid=[];
        this.loadmodel(url,modelname);
    }
    loadmodel(url,modelname){
        this.engine.displayLoadingUI();
        
        BABYLON.SceneLoader.ImportMesh("", url, modelname+".glb", this.scene, 
            (result)=> {                    
                result[0].name=modelname;
                //result[0].physicsImpostor = new BABYLON.PhysicsImpostor(result[0], BABYLON.PhysicsImpostor.BoxImpostor, { mass: 0, friction: 0.5, restitution: 0 }, this.scene);
                
                var meshall=result[0].getChildMeshes();

                // meshall=meshall.getChildMeshes();
                meshall.forEach(element => {
                    this.normalDisplayMaterials.push(element.material);
                    //element.receiveShadows = true;
                    element.checkCollisions = true;
                    //element.physicsImpostor = new BABYLON.PhysicsImpostor(element, BABYLON.PhysicsImpostor.MeshImpostor, { mass: 0, friction: 0.5, restitution: 0 }, this.scene);
                });
                meshall[0].name = "geo";
                this.model=meshall[0]; 

                meshall[0].position = BABYLON.Vector3.Zero();   
                meshall[0].computeWorldMatrix();
                
                //meshall[0].updateFacetData();
                // var size = meshall[0].getBoundingInfo().boundingBox.extendSize;
                // this.size = size;
                // var sx = 100 / size.x;
                // var sy = 100 / size.y;
                // var sz = 100 / size.z;
                // meshall[0].scaling = new BABYLON.Vector3(sx , sy, sz);
                // meshall[0].refreshBoundingInfo();
                //console.log(meshall[0].getBoundingInfo().boundingBox.extendSize);
                var vectorsWorld = meshall[0].getBoundingInfo().boundingBox.vectorsWorld;
                console.log(vectorsWorld);
                // console.log(meshall[0].scaling);
                //meshall[0].scaling.scaleInPlace(2000 / meshall[0].getBoundingInfo().boundingSphere.radius);
                this.scene.activeCamera.target = meshall[0].getBoundingInfo().boundingBox.centerWorld;
                //meshall[0].position = new BABYLON.Vector3(-2600,0,2600);

                let skyMaterial = new Material.SkyMaterial("skyMaterial", this.scene);
                skyMaterial.backFaceCulling = false;
                let skybox = BABYLON.Mesh.CreateBox("skyBox", Math.abs(Number(vectorsWorld[1].x))*10, this.scene);
                skybox.isPickable = false;
                skybox.material = skyMaterial;
                skyMaterial.inclination=0;
                this.scene.activeCamera.maxZ = 50000;

                this.showAxis(2000,this.scene,meshall[0].getBoundingInfo().boundingBox.centerWorld)
                //this.createMeshGrid(10,true);
                this.engine.hideLoadingUI();
        });
        
    }
    dispose(){
        if(this.model!=null){
            this.model.dispose();
        }
    }
    xrayDisplay(){
        var xray_mat = new BABYLON.StandardMaterial("xray", this.scene);
        xray_mat.emissiveColor = new BABYLON.Color3(1, 1, 1);
        xray_mat.alpha = 0.1;
        //this.model.material = xray_mat;
        var meshall=this.model.getChildMeshes();
        //console.log(meshall);
        if(meshall.length==0){
            this.model.material = xray_mat;
        }
        // meshall=meshall.getChildMeshes();
        meshall.forEach(element => {
            element.material = xray_mat;
        });
        this.xray=true;
    }
    normalDisplay(){
        var meshall=this.model.getChildMeshes();
        meshall.forEach((element) => {
            this.normalDisplayMaterials.push(element.material);
            element.material= this.normalDisplayMaterials[0];
        });
        this.xray=false;
    }
    gridOff(){
        this.grid.forEach(item=>item.isVisible=false);
    }
    createMeshGrid(slicer,xray){
        this.model.showBoundingBox = true;
        // var width = this.model.geometry.extend.maximum.x-this.model.geometry.extend.minimum.x;
        // var height = this.model.geometry.extend.maximum.y-this.model.geometry.extend.minimum.y;
        // var z = this.model.geometry.extend.maximum.z-this.model.geometry.extend.minimum.z;
        var vectorsWorld = this.model.getBoundingInfo().boundingBox.vectorsWorld; 
        var width =Math.abs(Number(vectorsWorld[1].x-(vectorsWorld[0].x)));
        var height=Math.abs(Number(vectorsWorld[1].y-(vectorsWorld[0].y)));
        var z = Math.abs(Number(vectorsWorld[1].z-(vectorsWorld[0].z)));
        console.log(width,height,z);
        
        
        var q = 0;
        var slice = slicer;
        var sizes = Math.sqrt(width*z)/slice;
        var cube = BABYLON.MeshBuilder.CreateBox("0",{size:sizes},this.scene);
        //cube.position = new BABYLON.Vector3(-width/2+sizes/2,-height/2+sizes/2,z/2-sizes/2);
        cube.isPickable = false;
        
        if(xray){
            var xray_mat = new BABYLON.StandardMaterial("xray", this.scene);
            xray_mat.emissiveColor = new BABYLON.Color3(1, 0, 0);
            xray_mat.alpha = 0.1;
            xray_mat.backFaceCulling = false;
            cube.material = xray_mat;
            // var mat = new BABYLON.StandardMaterial("mat", this.scene);
            // mat.wireframe = true;
            // cube.material = mat;
        }
        var h = height/sizes;
        var zz = z/sizes;
        var w = width/sizes
        var l = sizes;
        for(var i=0;i<h;i++){
            for(var j=0;j<zz;j++){
                for(var k=0;k<w;k++){
                    q++
                    var cubeIns = cube.createInstance("grid"+q);
                    cubeIns.isPickable = false;
                    //cubeIns.parent = cube;
                    this.grid.push(cubeIns);
                    cubeIns.position = new BABYLON.Vector3(-sizes/2,sizes/2,-sizes/2);
                    //cubeIns.position = new BABYLON.Vector3(-width/2+sizes/2,-height/2+sizes/2,z/2-sizes/2);
                    //cubeIns.position = new BABYLON.Vector3(0,0,0);
                    cubeIns.position.x-=l*k;
                    cubeIns.position.y+=l*i;
                    cubeIns.position.z-=l*j;
                }
            }
        }
    }

    showAxis(size,scene,pos) {
        var makeTextPlane = function(text, color, size) {
        var dynamicTexture = new BABYLON.DynamicTexture("DynamicTexture", 50, scene, true);
        dynamicTexture.hasAlpha = true;
        dynamicTexture.drawText(text, 5, 40, "bold 36px Arial", color , "transparent", true);
        var plane = new BABYLON.Mesh.CreatePlane("TextPlane", size, scene, true);
        plane.material = new BABYLON.StandardMaterial("TextPlaneMaterial", scene);
        plane.material.backFaceCulling = false;
        plane.material.specularColor = new BABYLON.Color3(0, 0, 0);
        plane.material.diffuseTexture = dynamicTexture;
        return plane;
         };
      
         var Axis = BABYLON.Mesh.CreateBox("skyBox", 1, this.scene);
        var axisX = BABYLON.Mesh.CreateLines("axisX", [ 
          new BABYLON.Vector3.Zero(), new BABYLON.Vector3(size, 0, 0), new BABYLON.Vector3(size * 0.95, 0.05 * size, 0), 
          new BABYLON.Vector3(size, 0, 0), new BABYLON.Vector3(size * 0.95, -0.05 * size, 0)
          ], scene);
        axisX.color = new BABYLON.Color3(1, 0, 0);
        var xChar = makeTextPlane("X", "red", size / 10);
        xChar.position = new BABYLON.Vector3(0.9 * size, -0.05 * size, 0);
        var axisY = BABYLON.Mesh.CreateLines("axisY", [
            new BABYLON.Vector3.Zero(), new BABYLON.Vector3(0, size, 0), new BABYLON.Vector3( -0.05 * size, size * 0.95, 0), 
            new BABYLON.Vector3(0, size, 0), new BABYLON.Vector3( 0.05 * size, size * 0.95, 0)
            ], scene);
        axisY.color = new BABYLON.Color3(0, 1, 0);
        var yChar = makeTextPlane("Y", "green", size / 10);
        yChar.position = new BABYLON.Vector3(0, 0.9 * size, -0.05 * size);
        var axisZ = BABYLON.Mesh.CreateLines("axisZ", [
            new BABYLON.Vector3.Zero(), new BABYLON.Vector3(0, 0, size), new BABYLON.Vector3( 0 , -0.05 * size, size * 0.95),
            new BABYLON.Vector3(0, 0, size), new BABYLON.Vector3( 0, 0.05 * size, size * 0.95)
            ], scene);
        axisZ.color = new BABYLON.Color3(0, 0, 1);
        var zChar = makeTextPlane("Z", "blue", size / 10);
        zChar.position = new BABYLON.Vector3(0, 0.05 * size, 0.9 * size);

        xChar.parent=axisX;
        yChar.parent=axisY;
        zChar.parent=axisZ;
        axisX.parent=Axis;
        axisY.parent=Axis;
        axisZ.parent=Axis;
        
        Axis.position = pos;
      };
}
export class GeomodelAxios{
    constructor(game,data,id,modelInform){
        this.scene=game.scene;
        this.engine = game.engine;
        this.xray=false;
        this.normalDisplayMaterials = [];
        this.model = null;
        this.size = null;
        this.id = id;
        this.modelInform = modelInform;
        this.grid=[];
        if(data===0){
            //console.log("glbModel");
            this.loadGlbModel(data);
        }else{
            this.buildModel(data);
        }
        
        
    }
    loadGlbModel(data){
        BABYLON.SceneLoader.ImportMesh("","/assets/models/geomodels/"+this.modelInform.uploaderId+"/",this.modelInform.fileName,this.scene, 
            (result)=> {
                result[0].name = "geo";
                result[0].getChildren()[0].name = "geo";
                result[0].computeWorldMatrix();
                result[0].scaling = new BABYLON.Vector3(1,1,-1);
                result[0].rotation = new BABYLON.Vector3(0,0,0);
                //得到真正的mesh：result[0].getChildMeshes()[0]
                this.model=result[0].getChildMeshes()[0];
                //console.log();
                //this.scene.activeCamera.target = result[0].getBoundingInfo().boundingBox.centerWorld;
                //var vectorsWorld = result[0].getBoundingInfo().boundingBox.vectorsWorld;
                
                // let skyMaterial = new Material.SkyMaterial("skyMaterial", this.scene);
                // skyMaterial.backFaceCulling = false;
                // let skybox = BABYLON.Mesh.CreateBox("skyBox", 8000, this.scene);
                // skybox.isPickable = false;
                // skybox.material = skyMaterial;
                // skyMaterial.inclination=0;

                //this.scene.debugLayer.show();
                //this.showAxis(1000,this.scene,result[0].getBoundingInfo().boundingBox.centerWorld);
                let max = result[0].getHierarchyBoundingVectors().max;
                let min = result[0].getHierarchyBoundingVectors().min;
               
                let size = max.subtract(min);

                let center = max.add(min);
                this.showAxis(size.x/1.3,this.scene,center);
                //console.log(center)
                this.scene.activeCamera.target = center;
                this.creatSkyBox(size);
            });
    }
    buildModel(data){
        var customMesh = new BABYLON.Mesh("geo", this.scene);
        var vertexData = new BABYLON.VertexData();
        //console.log(data);
        vertexData.positions = data.positions;
        vertexData.indices = data.faces;

        //Apply vertexData to custom mesh
        vertexData.applyToMesh(customMesh);

        var geomat =new BABYLON.StandardMaterial("geo",this.scene);
        geomat.specularColor = new BABYLON.Color3(0, 0, 0);
        geomat.emissiveColor = new BABYLON.Color3(0.5, 0.5, 0.5);
        customMesh.material = geomat;

        if(data.colors !== []){
            customMesh.setVerticesData(BABYLON.VertexBuffer.ColorKind, data.colors);
        }
        else{
            customMesh.material.emissiveColor = new BABYLON.Color3(69/255, 179/255, 157/255);
            customMesh.material.specularColor = new BABYLON.Color3(1, 1, 1);
            console.log("colors is null");
        }
        
        
        customMesh.computeWorldMatrix();
        this.model=customMesh;
        this.scene.activeCamera.target = customMesh.getBoundingInfo().boundingBox.centerWorld;

        var vectorsWorld = customMesh.getBoundingInfo().boundingBox.vectorsWorld;
        //console.log(vectorsWorld);
        //this.scene.debugLayer.show();
        this.showAxis(vectorsWorld[1].x/1.3,this.scene,customMesh.getBoundingInfo().boundingBox.centerWorld);

        //this.importhard()

        // let skyMaterial = new Material.SkyMaterial("skyMaterial", this.scene);
        // skyMaterial.backFaceCulling = false;
        // let skybox = BABYLON.Mesh.CreateBox("skyBox", Math.abs(Number(vectorsWorld[1].x))*10, this.scene);
        // skybox.isPickable = false;
        // skybox.material = skyMaterial;
        // skyMaterial.inclination=0;
        // this.scene.activeCamera.maxZ = 50000;
        
        //this.loadGlbModel(data);
        //this.createMeshGrid(10,true);
        //this.engine.hideLoadingUI();
        this.creatSkyBox(vectorsWorld[1]);
    }

    creatSkyBox(size){
        let skyMaterial = new Material.SkyMaterial("skyMaterial", this.scene);
        skyMaterial.backFaceCulling = false;
        //console.log(Math.abs(Number(size.x)))
        let skybox = BABYLON.Mesh.CreateBox("skyBox", Math.abs(Number(size.x))*10, this.scene);
        skybox.isPickable = false;
        skybox.material = skyMaterial;
        skyMaterial.inclination=0;
        this.scene.activeCamera.maxZ = 50000;
    }

   
    showAxis(size,scene,pos) {
        var makeTextPlane = function(text, color, size) {
        var dynamicTexture = new BABYLON.DynamicTexture("DynamicTexture", 50, scene, true);
        dynamicTexture.hasAlpha = true;
        dynamicTexture.drawText(text, 5, 40, "bold 36px Arial", color , "transparent", true);
        var plane = new BABYLON.Mesh.CreatePlane("TextPlane", size, scene, true);
        plane.material = new BABYLON.StandardMaterial("TextPlaneMaterial", scene);
        plane.material.backFaceCulling = false;
        plane.material.specularColor = new BABYLON.Color3(0, 0, 0);
        plane.material.diffuseTexture = dynamicTexture;
        return plane;
         };
      
         var Axis = BABYLON.Mesh.CreateBox("skyBox", 1, this.scene);
        var axisX = BABYLON.Mesh.CreateLines("axisX", [ 
          new BABYLON.Vector3.Zero(), new BABYLON.Vector3(size, 0, 0), new BABYLON.Vector3(size * 0.95, 0.05 * size, 0), 
          new BABYLON.Vector3(size, 0, 0), new BABYLON.Vector3(size * 0.95, -0.05 * size, 0)
          ], scene);
        axisX.color = new BABYLON.Color3(1, 0, 0);
        var xChar = makeTextPlane("X", "red", size / 10);
        xChar.position = new BABYLON.Vector3(0.9 * size, -0.05 * size, 0);
        var axisY = BABYLON.Mesh.CreateLines("axisY", [
            new BABYLON.Vector3.Zero(), new BABYLON.Vector3(0, size, 0), new BABYLON.Vector3( -0.05 * size, size * 0.95, 0), 
            new BABYLON.Vector3(0, size, 0), new BABYLON.Vector3( 0.05 * size, size * 0.95, 0)
            ], scene);
        axisY.color = new BABYLON.Color3(0, 1, 0);
        var yChar = makeTextPlane("Y", "green", size / 10);
        yChar.position = new BABYLON.Vector3(0, 0.9 * size, -0.05 * size);
        var axisZ = BABYLON.Mesh.CreateLines("axisZ", [
            new BABYLON.Vector3.Zero(), new BABYLON.Vector3(0, 0, size), new BABYLON.Vector3( 0 , -0.05 * size, size * 0.95),
            new BABYLON.Vector3(0, 0, size), new BABYLON.Vector3( 0, 0.05 * size, size * 0.95)
            ], scene);
        axisZ.color = new BABYLON.Color3(0, 0, 1);
        var zChar = makeTextPlane("Z", "blue", size / 10);
        zChar.position = new BABYLON.Vector3(0, 0.05 * size, 0.9 * size);

        xChar.parent=axisX;
        yChar.parent=axisY;
        zChar.parent=axisZ;
        axisX.parent=Axis;
        axisY.parent=Axis;
        axisZ.parent=Axis;
        
        Axis.position = pos;
      };

      dispose(){
        if(this.model!=null){
            this.model.dispose();
        }
    }
    xrayDisplay(){
        var xray_mat = new BABYLON.StandardMaterial("xray", this.scene);
        xray_mat.emissiveColor = new BABYLON.Color3(1, 1, 1);
        xray_mat.alpha = 0.1;
        //this.model.material = xray_mat;
        var meshall=this.model.getChildMeshes();
        //console.log(meshall);
        if(meshall.length==0){
            this.model.material = xray_mat;
        }
        // meshall=meshall.getChildMeshes();
        meshall.forEach(element => {
            element.material = xray_mat;
        });
        this.xray=true;
    }
    normalDisplay(){
        var meshall=this.model;
       
            this.normalDisplayMaterials.push(meshall.material);
            meshall.material= this.normalDisplayMaterials[0];

        this.xray=false;
    }
    gridOff(){
        this.grid.forEach(item=>item.isVisible=false);
    }
    createMeshGrid(slicer,xray){
        this.model.showBoundingBox = true;
        // var width = this.model.geometry.extend.maximum.x-this.model.geometry.extend.minimum.x;
        // var height = this.model.geometry.extend.maximum.y-this.model.geometry.extend.minimum.y;
        // var z = this.model.geometry.extend.maximum.z-this.model.geometry.extend.minimum.z;
        var vectorsWorld = this.model.getBoundingInfo().boundingBox.vectorsWorld; 
        var width =Math.abs(Number(vectorsWorld[1].x-(vectorsWorld[0].x)));
        var height=Math.abs(Number(vectorsWorld[1].y-(vectorsWorld[0].y)));
        var z = Math.abs(Number(vectorsWorld[1].z-(vectorsWorld[0].z)));
        console.log(width,height,z);
        
        
        var q = 0;
        var slice = slicer;
        var sizes = Math.sqrt(width*z)/slice;
        var cube = BABYLON.MeshBuilder.CreateBox("0",{size:sizes},this.scene);
        //cube.position = new BABYLON.Vector3(-width/2+sizes/2,-height/2+sizes/2,z/2-sizes/2);
        cube.isPickable = false;
        
        if(xray){
            var xray_mat = new BABYLON.StandardMaterial("xray", this.scene);
            xray_mat.emissiveColor = new BABYLON.Color3(1, 0, 0);
            xray_mat.alpha = 0.1;
            xray_mat.backFaceCulling = false;
            cube.material = xray_mat;
            // var mat = new BABYLON.StandardMaterial("mat", this.scene);
            // mat.wireframe = true;
            // cube.material = mat;
        }
        var h = height/sizes;
        var zz = z/sizes;
        var w = width/sizes
        var l = sizes;
        for(var i=0;i<h;i++){
            for(var j=0;j<zz;j++){
                for(var k=0;k<w;k++){
                    q++
                    var cubeIns = cube.createInstance("grid"+q);
                    cubeIns.isPickable = false;
                    //cubeIns.parent = cube;
                    this.grid.push(cubeIns);
                    cubeIns.position = new BABYLON.Vector3(-sizes/2,sizes/2,-sizes/2);
                    //cubeIns.position = new BABYLON.Vector3(-width/2+sizes/2,-height/2+sizes/2,z/2-sizes/2);
                    //cubeIns.position = new BABYLON.Vector3(0,0,0);
                    cubeIns.position.x-=l*k;
                    cubeIns.position.y+=l*i;
                    cubeIns.position.z-=l*j;
                }
            }
        }
    }
    importhard(){
        BABYLON.SceneLoader.ImportMesh("","/assets/models/","hard.obj",this.scene, 
            (result)=> {
                var mat =new BABYLON.StandardMaterial("hard.obj", this.scene);
                result[1].material = mat;
            });
    }
}